// Mirrors "is this field filled in?" for client-side progress hints. The
// server stays the source of truth for validation.
export function fieldGroup (root, fieldId) {
  const label = root.querySelector(`label[for="${fieldId}"]`)

  return (label || document.getElementById(fieldId))?.closest(".form-group")
}

// `data-unless-checked` / `data-if-checked` hold the id of a checkbox of the
// form: the element applies only while it is off / on (e.g. registering a
// student drops the RPPS and the company from the requirements).
export function appliesToForm (root, element) {
  const { unlessChecked, ifChecked } = element.dataset

  if (unlessChecked && isChecked(root, unlessChecked)) return false
  if (ifChecked && !isChecked(root, ifChecked)) return false
  return true
}

function isChecked (root, id) {
  const checkbox = root.querySelector(`[id="${id}"]`)

  return Boolean(checkbox?.checked)
}

export function isFieldShown (group) {
  return !group.closest(".d-none, [hidden]")
}

export function isFieldFilled (group) {
  const controls = group.querySelectorAll("input:not([type=hidden]), select, textarea")

  return Array.from(controls).some((control) => {
    if (control.type === "radio") return control.checked
    if (control.type === "checkbox") return false

    const minLength = Math.max(Number(control.getAttribute("minlength")) || 0, 1)

    return control.value.trim().length >= minLength
  })
}
